/**
 * File table-highlight.js.
 * Handles column highlight feature for desktop tables
 * Handles borders removal for mobile tables with row highlight
 */

const desktopTablesHighlighted = document.querySelectorAll('.mock-table--desktop.mock-table--highlighted');
const mobileCellHighlighted = document.querySelectorAll('.mock-table--mobile .mock-table__content--highlighted');
const mobileHighlightedSliderCells = document.querySelectorAll('.mock-table--mobile.mock-table--highlighted-slider .mock-table__content--non-first');
const mobileSliderTablesHighlighted = document.querySelectorAll('.mock-table--mobile.mock-table--highlighted-slider');
const mobileCardsTablesHighlighted = document.querySelectorAll('.mock-table--mobile.mock-table--highlighted-cards');

// loop desktop tables
if (desktopTablesHighlighted.length) {
  for (var t = 0; t < desktopTablesHighlighted.length; t++) {
    let offsetLeftCalc = 0;
    const table = desktopTablesHighlighted[t];
    const cells = table.querySelectorAll('.mock-table__cell');

    // get highlight's max width, convert to integer
    const highlight = table.querySelector('.highlight');
    
    // loop desktop table cells
    if (cells.length) {
      let cell, cellMaxWidth = 0;
      let cellStyle;
      for (var c = 0; c < cells.length; c++) {
        cell = cells[c];

        // once loop reaches a highlighted cell, move the highlight and display it
        if (cell.classList.contains('mock-table__cell--highlighted')) {
          highlight.style.left = offsetLeftCalc+'%';
          highlight.style.opacity = '1';
          break;
        }

        // calculate left offset
        cellStyle = getComputedStyle(cell);
        cellMaxWidth = parseInt(cellStyle.maxWidth.replace('px',''));
        offsetLeftCalc += cellMaxWidth;
      }
    }
  }
}

// remove border from mobile table rows with highlight
if (mobileCellHighlighted.length) {
  for (var r = 0; r < mobileCellHighlighted.length; r++) {
    let cell = mobileCellHighlighted[r];
    cell.previousElementSibling.style.border = 'none';

    // move highlighted cell to first cell in mobile table
    cell.parentElement.prepend(cell);
  }
}

// swap content item positions
if (mobileHighlightedSliderCells.length) {
  for (let i = 0; i < mobileHighlightedSliderCells.length; i++) {
    let lastChild = mobileHighlightedSliderCells[i].querySelector('.mock-table__content-item--value');;
    lastChild.parentNode.insertBefore(lastChild, lastChild.previousElementSibling);
  }
}

// move non-highlighted cells into slick container
if (mobileSliderTablesHighlighted.length) {
  for (var t = 0; t < mobileSliderTablesHighlighted.length; t++) {
    const table = mobileSliderTablesHighlighted[t];
    const cells = table.querySelectorAll('.mock-table__content:not(.mock-table__content--highlighted)');
    // if there are more than 2 cells, populate slick container
    if (cells.length > 2) {
      const cellsSlider = document.createElement('div');
      cellsSlider.classList.add('mock-table__slide-wrapper');
      for (let i = 0; i < cells.length; i++) {
        cellsSlider.append(cells[i]);
      }
      table.append(cellsSlider);
    }
  }
}

// wiggle slider when in viewport
let wiggleSlider = (entries, observer) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      const slickTrack = entry.target.querySelector('.slick-track');
      slickTrack.classList.add('slick-track--wiggle');
      observer.unobserve(entry.target);
    }
  });
};

let sliderObserver = new IntersectionObserver(wiggleSlider, {
  threshold: 1
});

function prepCardSlider($) {
  const initiateCardSlider = (slider) => {
    let settings = {
      dots: false,
      arrows: false,
      speed: 300,
      slidesToShow: 1,
      adaptiveHeight: false,
      autoplay: false,
      infinite: false,
    };

    $(slider).slick(settings);
  }

  // move non-highlighted cards into slider wrapper + initiate slider
  for (var t = 0; t < mobileCardsTablesHighlighted.length; t++) {
    const table = mobileCardsTablesHighlighted[t];
    const card = table.querySelector('.responsive-table-card');
    const slider = document.querySelector('.responsive-table-cards__slider');

    if (card && !card.classList.contains('responsive-table-card--highlighted')) {
      slider.append(card.closest('.responsive-table'));
    }

    if (t === mobileCardsTablesHighlighted.length - 1) {
      setTimeout(() => {
        if (slider) initiateCardSlider(slider);
      }, 0);
    }
  }
}

// init mobile table sliders
function mobileTableInit($) {
  const mockTableSliders = document.querySelectorAll('.mock-table__slide-wrapper');
  
  function initSlider(slider) {
    const dotsWrapper = $(slider).parent().siblings('.mock-table__dots-wrapper');
    const settings = {
      infinite: false,
      arrows: false,
      dots: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      lazyLoad: 'anticipated',
      enterMode: true,
      centerPadding: '0px',
      appendDots: dotsWrapper,
    };

    // Set/unset slider depending on screen size
    function checkSlider() {
      const bIsMobile = typeof isMobile == 'function' && isMobile();
      if(!bIsMobile && $(slider).hasClass('slick-initialized')) {
        $(slider).slick('unslick');
      } else if (bIsMobile && !$(slider).hasClass('slick-initialized')) {
        $(slider).slick(settings);
      }
    }

    // Check slider on window resize
    $(window).on('resize', function() {
      checkSlider();
    });
    
    checkSlider();
  }

  mockTableSliders.forEach(slider => {
    // use setTimeout to initialize each slider in its own JS task to avoid long-running JS tasks
    setTimeout(() => {
      initSlider(slider);
      sliderObserver.observe(slider);
    }, 0);
  });
}

// Inits
if (typeof jQuery !== 'undefined') jQuery(function($) {
  mobileTableInit($);
  if (mobileCardsTablesHighlighted.length) prepCardSlider($);
});